var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component } from 'angular-ts-decorators';
let QuestionnaireController = class QuestionnaireController {
    $http;
    $scope;
    $timeout;
    organizationService;
    orgas = [];
    orgasLoading = false;
    modalOrgaFilter = '';
    modalModel = {
        organization: '',
        questionnaireId: '',
    };
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$http', '$scope', '$timeout', 'OrganizationService'];
    constructor($http, $scope, $timeout, organizationService) {
        this.$http = $http;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.organizationService = organizationService;
        $scope.$watch(() => this.modalOrgaFilter, this.filterOrgas.bind(this));
    }
    async filterOrgas() {
        this.orgasLoading = true;
        try {
            // We only trigger a search when we have more than three characters to reduce database load
            if (this.modalOrgaFilter.length >= 3) {
                this.orgas = (await this.organizationService.getOrganizations(0, // Page
                50, // Page-Size (Limit)
                this.modalOrgaFilter, // Filter
                false, // encodeIds
                false, // onlyOrga
                false)).orgas;
                if (this.orgas.length > 0) {
                    this.modalModel.organization = this.orgas[0].organization_id;
                }
            }
            else {
                // Reset back to defaults
                this.orgas = [];
                this.modalModel.organization = '';
            }
        }
        finally {
            this.orgasLoading = false;
        }
        // Apply changes to view
        this.$timeout(() => (this.$scope.modalModel = this.modalModel));
    }
    openModal() {
        this.modalOrgaFilter = '';
        // get last element of path as it should contain the questionnaire id
        const currentQuestionnaireId = window.location.pathname.split('/')[3];
        if (!currentQuestionnaireId || currentQuestionnaireId.length !== 16) {
            window.alert('Must be in the configurator of a template');
            return;
        }
        $('#questionnaire_move_modal').modal();
        this.$timeout(function () {
            $('#questionnaire_move_modal [ng-model="main.modalOrgaFilter"]').focus();
        }, 500);
    }
    onModalClose() {
        const currentQuestionnaireId = window.location.pathname.split('/')[3];
        const request = this.$http.patch(`/visitreport/v1/questionnaire/${currentQuestionnaireId}/move-organization/${this.modalModel.organization}`, undefined);
        request
            .then((_response) => {
            window.location.href = '/questions';
        })
            .catch((err) => {
            console.error('Failed to move questionnaire', err);
            alert('Error while moving questionnaire. Please see console for details.');
        });
    }
};
QuestionnaireController = __decorate([
    Component({
        selector: 'app-questionnaire-controller',
        // no associated template, is embedded static HTML-page in the server assets
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.IHttpService) === "function" ? _a : Object, typeof (_b = typeof QuestionnaireControllerScope !== "undefined" && QuestionnaireControllerScope) === "function" ? _b : Object, typeof (_c = typeof ng !== "undefined" && ng.ITimeoutService) === "function" ? _c : Object, Object])
], QuestionnaireController);
export { QuestionnaireController };
